import { PRIORAUTH_TURNAROUND_TIME_CANCEL } from '../actionTypes';
import { CASE_SUBMISSION_DETAILS_CANCEL } from '../actionTypes';
import {
  PRIORAUTH_TAX_ID_QUICKFILTER_DATA_REQUEST,
  PRIORAUTH_TAX_ID_QUICKFILTER_DATA_SUCCESS,
  PRIORAUTH_TAX_ID_QUICKFILTER_DATA_FAILURE,
  PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_REQUEST,
  PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_SUCCESS,
  PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_FAILURE,
  PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_REQUEST,
  PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_SUCCESS,
  PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_FAILURE,
  PRIORAUTH_METRIC_DEFINITIONS_DATA_REQUEST,
  PRIORAUTH_METRIC_DEFINITIONS_DATA_SUCCESS,
  CASE_SUBMISSION_DETAILS_REQUEST,
  CASE_SUBMISSION_DETAILS_SUCCESS,
  CASE_SUBMISSION_DETAILS_ERROR,
  CASE_SUBMISSION_DETAILS_LOADING,
  PRIORAUTH_TURNAROUND_TIME_REQUEST,
  PRIORAUTH_TURNAROUND_TIME_SUCCESS,
  PRIORAUTH_TURNAROUND_TIME_ERROR,
  PRIORAUTH_TURNAROUND_TIME_LOADING,
  PRIORAUTH_METRIC_DEFINITIONS_DATA_FAILURE,
  INSIGHT_CARD_DATA_REQUEST,
  INSIGHT_CARD_DATA_SUCCESS,
  INSIGHT_CARD_DATA_FAILURE,
  CASE_SUBMISSION_CHANNELS_DATA_REQUEST,
  CASE_SUBMISSION_CHANNELS_DATA_SUCCESS,
  CASE_SUBMISSION_CHANNELS_DATA_FAILURE,
  CASE_SUBMISSIONS_OVER_TIME_DATA_REQUEST,
  CASE_SUBMISSIONS_OVER_TIME_DATA_SUCCESS,
  CASE_SUBMISSIONS_OVER_TIME_DATA_FAILURE,
  CASE_SUBMISSIONS_OVER_TIME_LOADING,
  FETCH_PRIOR_AUTH_TIN_REQUEST,
  FETCH_PRIOR_AUTH_TIN_SUCCESS,
  FETCH_PRIOR_AUTH_TIN_ERROR,
  FETCH_PRIOR_AUTH_TIN_LOADING,
  INSIGHT_CARD_LOADING,
  SET_PRIORAUTH_FILTERS,
  UPDATE_PRIORAUTH_FILTER,
  RESET_PRIORAUTH_FILTER,
  PRIORAUTH_FILTERS_CHANGED,
  SET_PRIORAUTH_BASE_PAYLOAD,
  CASE_SUBMISSION_CHANNELS_LOADING,
  PRIORAUTH_POLLING_STARTED,
  PRIORAUTH_POLLING_COMPLETED,
  PRIORAUTH_POLLING_FAILED,
  PRIORAUTH_POLLING_RESET,
  PRIORAUTH_GLOBAL_FILTERS_APPLY,
  PRIORAUTH_GLOBAL_FILTERS_RESET,
  PRIORAUTH_GLOBAL_FILTERS_UPDATE,
  SET_PA_TIN_COUNT,
} from '../actionTypes';

// Filter Management Actions
export const setPaTinCount = (count: number) => ({
  type: SET_PA_TIN_COUNT,
  payload: count,
});

export const setPriorAuthFilters = (filters: any) => ({
  type: SET_PRIORAUTH_FILTERS,
  payload: filters,
});

export const updatePriorAuthFilter = (filterId: string, value: any) => ({
  type: UPDATE_PRIORAUTH_FILTER,
  payload: { filterId, value },
});

export const resetPriorAuthFilter = (filterId: string) => ({
  type: RESET_PRIORAUTH_FILTER,
  payload: filterId,
});

export const priorAuthFiltersChanged = (filters: any) => ({
  type: PRIORAUTH_FILTERS_CHANGED,
  payload: filters,
});

export const setPriorAuthBasePayload = (payload: any) => ({
  type: SET_PRIORAUTH_BASE_PAYLOAD,
  payload,
});

// Global Filter Actions
export const applyPriorAuthGlobalFilters = (filters: any) => ({
  type: PRIORAUTH_GLOBAL_FILTERS_APPLY,
  payload: filters,
});

export const resetPriorAuthGlobalFilters = () => ({
  type: PRIORAUTH_GLOBAL_FILTERS_RESET,
});

export const updatePriorAuthGlobalFilter = (filterKey: string, value: any) => ({
  type: PRIORAUTH_GLOBAL_FILTERS_UPDATE,
  payload: { filterKey, value },
});

export const getPriorAuthTaxIdQuickFilterDataRequest = (payload: any) => ({
  type: PRIORAUTH_TAX_ID_QUICKFILTER_DATA_REQUEST,
  payload,
});
export const getPriorAuthTaxIdQuickFilterDataSuccess = (payload: any) => ({
  type: PRIORAUTH_TAX_ID_QUICKFILTER_DATA_SUCCESS,
  payload,
});
export const getPriorAuthTaxIdQuickFilterDataError = (payload: any) => ({
  type: PRIORAUTH_TAX_ID_QUICKFILTER_DATA_FAILURE,
  payload,
});

export const getPriorAuthAllProvidersQuickFilterDataRequest = (
  payload: any
) => ({
  type: PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_REQUEST,
  payload,
});

export const getPriorAuthAllProvidersQuickFilterDataSuccess = (
  payload: any
) => ({
  type: PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_SUCCESS,
  payload,
});
export const getPriorAuthAllProvidersQuickFilterDataError = (payload: any) => ({
  type: PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_FAILURE,
  payload,
});

export const getPriorAuthExtendedTinsTopFilterDataRequest = (payload: any) => ({
  type: PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_REQUEST,
  payload,
});
export const getPriorAuthExtendedTinsTopFilterDataSuccess = (payload: any) => ({
  type: PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_SUCCESS,
  payload,
});
export const getPriorAuthExtendedTinsTopFilterDataError = (payload: any) => ({
  type: PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_FAILURE,
  payload,
});

export const getPriorAuthMetricDefinitionsDataRequest = () => ({
  type: PRIORAUTH_METRIC_DEFINITIONS_DATA_REQUEST,
});
export const getPriorAuthMetricDefinitionsDataSuccess = (payload: any) => ({
  type: PRIORAUTH_METRIC_DEFINITIONS_DATA_SUCCESS,
  payload,
});
export const getPriorAuthMetricDefinitionsDataError = (payload: any) => ({
  type: PRIORAUTH_METRIC_DEFINITIONS_DATA_FAILURE,
  payload,
});

export const caseSubmissionChannelsLoading = (payload: boolean) => ({
  type: CASE_SUBMISSION_CHANNELS_LOADING,
  payload,
});

// Case Submission Details Actions
export const getCaseSubmissionDetailsRequest = (payload: any, key: any) => ({
  type: CASE_SUBMISSION_DETAILS_REQUEST,
  payload,
  key,
});

export const getCaseSubmissionDetailsSuccess = (payload: any) => ({
  type: CASE_SUBMISSION_DETAILS_SUCCESS,
  payload,
  tinCount: payload?.Data?.TinCount || 0 // ✅ Extract TinCount from response
});

export const getCaseSubmissionDetailsError = (payload: any) => ({
  type: CASE_SUBMISSION_DETAILS_ERROR,
  payload,
});

export const caseSubmissionDetailsLoading = (payload: boolean) => ({
  type: CASE_SUBMISSION_DETAILS_LOADING,
  payload,
});

export const insightCardLoading = (payload: boolean) => ({
  type: INSIGHT_CARD_LOADING,
  payload,
});

// Prior Auth Turnaround Time Actions
export const getPriorAuthTurnaroundTimeRequest = (
  payload: any,
  key: boolean
) => ({
  type: PRIORAUTH_TURNAROUND_TIME_REQUEST,
  payload,
  key,
});

export const getPriorAuthTurnaroundTimeSuccess = (payload: any) => ({
  type: PRIORAUTH_TURNAROUND_TIME_SUCCESS,
  payload,
});

export const getPriorAuthTurnaroundTimeError = (payload: any) => ({
  type: PRIORAUTH_TURNAROUND_TIME_ERROR,
  payload,
});

export const priorAuthTurnaroundTimeLoading = (payload: boolean) => ({
  type: PRIORAUTH_TURNAROUND_TIME_LOADING,
  payload,
});

export const getInsightCardDataRequest = (payload: any, key: any) => ({
  type: INSIGHT_CARD_DATA_REQUEST,
  payload,
  key,
});

export const getInsightCardDataSuccess = (payload: any) => ({
  type: INSIGHT_CARD_DATA_SUCCESS,
  payload,
});

export const getInsightCardDataError = (payload: any) => ({
  type: INSIGHT_CARD_DATA_FAILURE,
  payload,
});

export const getCaseSubmissionChannelsDataRequest = (payload: any, key: any) => ({
  type: CASE_SUBMISSION_CHANNELS_DATA_REQUEST,
  payload,
  key
});

export const getCaseSubmissionChannelsDataSuccess = (payload: any) => ({
  type: CASE_SUBMISSION_CHANNELS_DATA_SUCCESS,
  payload,
});

// Case Submissions Over Time Actions
export const getCaseSubmissionsOverTimeDataRequest = (payload: any) => {
  const { key, ...restPayload } = payload;
  return {
    type: CASE_SUBMISSIONS_OVER_TIME_DATA_REQUEST,
    payload: restPayload,
    key,
  };
};

export const getCaseSubmissionsOverTimeDataSuccess = (payload: any) => ({
  type: CASE_SUBMISSIONS_OVER_TIME_DATA_SUCCESS,
  payload,
});

export const getCaseSubmissionsOverTimeDataError = (payload: any) => ({
  type: CASE_SUBMISSIONS_OVER_TIME_DATA_FAILURE,
  payload,
});

export const caseSubmissionsOverTimeLoading = (payload: boolean) => ({
  type: CASE_SUBMISSIONS_OVER_TIME_LOADING,
  payload,
});
export const getCaseSubmissionChannelsDataError = (payload: any) => ({
  type: CASE_SUBMISSION_CHANNELS_DATA_FAILURE,
  payload,
});

// Prior Auth TIN Details Actions
export const getPriorAuthTinDetailsRequest = (payload: any) => ({
  type: FETCH_PRIOR_AUTH_TIN_REQUEST,
  payload,
});

export const getPriorAuthTinDetailsSuccess = (payload: any) => ({
  type: FETCH_PRIOR_AUTH_TIN_SUCCESS,
  payload,
});

export const getPriorAuthTinDetailsError = (payload: any) => ({
  type: FETCH_PRIOR_AUTH_TIN_ERROR,
  payload,
});

export const priorAuthTinDetailsLoading = (payload: boolean) => ({
  type: FETCH_PRIOR_AUTH_TIN_LOADING,
  payload,
});

export const getCaseSubmissionDetailsCancel = () => ({
  type: CASE_SUBMISSION_DETAILS_CANCEL,
});

export const priorAuthTurnaroundTimeCancel = () => ({
  type: PRIORAUTH_TURNAROUND_TIME_CANCEL,
});

// Prior Auth Polling Status Actions
export const priorAuthPollingStarted = () => ({
  type: PRIORAUTH_POLLING_STARTED,
});

export const priorAuthPollingCompleted = () => ({
  type: PRIORAUTH_POLLING_COMPLETED,
});

export const priorAuthPollingFailed = (error: any) => ({
  type: PRIORAUTH_POLLING_FAILED,
  payload: error,
});

export const priorAuthPollingReset = () => ({
  type: PRIORAUTH_POLLING_RESET,
});

// PA Not Approved Reasons Actions
export const fetchPANotApprovedReasonsRequest = (payload: any, key?: any) => ({
  type: 'PRIORAUTH_NOT_APPROVED_REASONS_REQUEST',
  payload,
  key
});

export const fetchPANotApprovedReasonsSuccess = (data: any) => ({
  type: 'PRIORAUTH_NOT_APPROVED_REASONS_SUCCESS',
  payload: data
});

export const fetchPANotApprovedReasonsFailure = (error: string) => ({
  type: 'PRIORAUTH_NOT_APPROVED_REASONS_FAILURE',
  payload: error
});

export const setPANotApprovedLoading = (isLoading: boolean) => ({
  type: 'PRIORAUTH_NOT_APPROVED_REASONS_LOADING',
  payload: isLoading
});

// PA CPT Codes Actions
export const fetchPACPTCodesRequest = (payload: any, key?: any) => ({
  type: 'PRIORAUTH_CPT_CODES_REQUEST',
  payload,
  key
});

export const fetchPACPTCodesSuccess = (data: any) => ({
  type: 'PRIORAUTH_CPT_CODES_SUCCESS',
  payload: data
});

export const fetchPACPTCodesFailure = (error: string) => ({
  type: 'PRIORAUTH_CPT_CODES_FAILURE',
  payload: error
});

// CPT Approvals Actions
export const fetchCPTApprovalsRequest = (payload: any, key: any) => ({
  type: 'PRIORAUTH_CPT_APPROVALS_REQUEST',
  payload,
  key
});

export const fetchCPTApprovalsSuccess = (data: any) => ({
  type: 'PRIORAUTH_CPT_APPROVALS_SUCCESS',
  payload: data
});

export const fetchCPTApprovalsFailure = (error: string) => ({
  type: 'PRIORAUTH_CPT_APPROVALS_FAILURE',
  payload: error
});

export const setCPTApprovalsLoading = (loading: boolean) => ({
  type: 'SET_PRIORAUTH_CPT_APPROVALS_LOADING',
  payload: loading
});